import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Construction } from 'lucide-react';

export const AdminPlaceholder = ({
  title,
  phase,
  description,
  icon: Icon = Construction,
  bullets = [],
  testId,
}) => {
  return (
    <section data-testid={testId}>
      <div className="flex flex-col gap-2 mb-6">
        <span className="text-[11px] uppercase tracking-[0.25em] text-[var(--ns-gold-600)] font-semibold">
          {title}
        </span>
        <div className="flex items-center gap-3">
          <h1 className="font-display uppercase tracking-tight text-[var(--ns-text)] text-3xl sm:text-5xl leading-[1.02]">
            {title}
          </h1>
          <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] uppercase tracking-wider font-bold bg-[var(--ns-amber-100)] text-[var(--ns-gold-700)] border border-[var(--ns-gold)]/40">
            Próximamente · Fase {phase}
          </span>
        </div>
      </div>

      <Card className="bg-white border border-[var(--ns-border)] rounded-2xl shadow-[var(--ns-shadow-soft)] overflow-hidden">
        <CardContent className="p-8 sm:p-12">
          <div className="flex flex-col items-start sm:flex-row sm:items-center sm:gap-8">
            <div className="h-16 w-16 rounded-2xl bg-[var(--ns-amber-100)] border border-[var(--ns-gold)]/40 flex items-center justify-center mb-5 sm:mb-0">
              <Icon className="h-8 w-8 text-[var(--ns-gold-700)]" />
            </div>
            <div className="flex-1">
              <h2 className="font-display uppercase tracking-wide text-2xl text-[var(--ns-text)]">
                Esta sección aún no está implementada
              </h2>
              <p className="text-sm sm:text-base text-[var(--ns-text-muted)] mt-2 leading-relaxed max-w-xl">
                {description}
              </p>
              {bullets.length > 0 && (
                <ul className="mt-5 space-y-2">
                  {bullets.map((b, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm text-[var(--ns-text)]">
                      <span className="h-1.5 w-1.5 rounded-full bg-[var(--ns-gold)] mt-2 shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              )}
              <p className="text-xs text-[var(--ns-text-subtle)] mt-6">
                Esta versión del panel solo muestra la navegación. La funcionalidad real llegará en
                la Fase {phase}.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};
